import MRRTransactions from './MRRTransactions';

export default MRRTransactions;
